// "An ad is on screen right now" — the single flag the game pauses and mutes on.
//
// Y8's rule, which their QA checks explicitly: "Pause your game inside the before-ad
// callback and resume it inside the after-ad callback. Mute your audio in the same place
// you pause, and restore it in the same place you resume." ROOTKIN has no music, but it
// DOES make sound on its own: the transfer ticker in Layout plays a cue when a download
// finishes, so a cue could land in the middle of a full-screen ad. That is exactly what
// their QA looks for.
//
// What pausing means here, concretely:
//  * SFX are suspended (services/sfx.ts) — separately from the player's own mute toggle,
//    which is never touched: their preference must survive an ad unchanged;
//  * the transfer ticker skips its ticks (components/Layout.tsx). Ticks are incremental,
//    so a transfer is simply paused for the length of the ad and resumes where it was.
// Nothing else needs it: a minigame attempt runs on the SERVER's clock, which is why no ad
// is ever requested during one; everything else is waiting on the player.
//
// begin/end are idempotent. A FAILSAFE ends the break on its own if the SDK never calls
// back: a lost `afterAd` must not leave the game silent and its transfers frozen.
import { setAdSuspended } from './sfx';

const FAILSAFE_MS = 120_000; // longer than any ad; only fires if the SDK went quiet

let active = false;
let failsafe: ReturnType<typeof setTimeout> | null = null;

export function isAdBreakActive(): boolean { return active; }

export function beginAdBreak(): void {
  if (failsafe) clearTimeout(failsafe);
  failsafe = setTimeout(endAdBreak, FAILSAFE_MS);
  if (active) return;
  active = true;
  setAdSuspended(true);
}

export function endAdBreak(): void {
  if (failsafe) { clearTimeout(failsafe); failsafe = null; }
  if (!active) return;
  active = false;
  setAdSuspended(false);
}
